<div
  *ngFor="let line of lines"
  class="alert mb-3"
  [class.alert-danger]="line.active"
  [class.alert-warning]="!line.active"
  role="alert"
  data-testid="buyer-ordering-blackout-banner"
>
  {{ line.text }}
</div>
